import { Routes } from '@angular/router';
import { AppPage } from 'jk-service';
/*
import { StockPage } from './stock/stock.component';
import { Stkpb04Component } from './stkpb04/stkpb04.component';
import { Stkpi01BillComponent } from './stkpi01/stkpi01BillPkg.component';
import { Stkpi13BillComponent } from './stkpi13/stkpi13BillPkg.component';
import { Stkpi17BillComponent } from './stkpi17/stkpi17BillPkg.component';
import { Stkpi19BillComponent } from './stkpi19/stkpi19BillPkg.component';
import { Stkpi20BillComponent } from './stkpi20/stkpi20BillPkg.component';
import { Stkpq08Page } from './stkpq08/stkpq08.component';
import { Stkpq09Page } from './stkpq09/stkpq09.component';
import { Stkpq10Page } from './stkpq10/stkpq10.component';
import { Stkpq13Component } from './stkpq13/stkpq13.component';
import { Stkpq14Component } from './stkpq14/stkpq14.component';
import { Stkpq15Component } from './stkpq15/stkpq15.component';
import { Stkpq16Component } from './stkpq16/stkpq16.component';
import { Stkpq17Component } from './stkpq17/stkpq17.component';
import { Stkpq18Component } from './stkpq18/stkpq18.component';
import { Stkpq19Component } from './stkpq19/stkpq19.component';
*/

export const stkPages: AppPage[] = [
  // stock begin========
  {
    title: '股票走勢圖',
    url: '/stk/stock',
    icon: 'git-network',
    id: 'stock',
    isCheckPower: true,
  },
  {
    title: '下單作業',
    url: '/stk/stkpb04',
    id: 'stkpb04',
    isCheckPower: true,
  },
  {
    title: '資料維護作業',
    url: '/stk/stkpb05',
    id: 'stkpb05',
    isCheckPower: true,
  },
  {
    title: '追蹤股票查詢',
    url: '/stk/stkpq09',
    id: 'stkpq09',
    isCheckPower: true,
  },
  {
    title: '股票通知查詢',
    url: '/stk/stkpq10',
    id: 'stkpq10',
    isCheckPower: true,
  },
  {
    title: '股票群組查詢',
    url: '/stk/stkpq13',
    id: 'stkpq13',
    isCheckPower: true,
  },
  {
    title: '選股中心查詢',
    url: '/stk/stkpq14',
    id: 'stkpq14',
    isCheckPower: true,
  },
  {
    title: '群組熱力圖查詢',
    url: '/stk/stkpq15',
    id: 'stkpq15',
    isCheckPower: true,
  },
  {
    title: '上市櫃財務查詢',
    url: '/stk/stkpq16',
    id: 'stkpq16',
    isCheckPower: true,
  },
  {
    title: '財務查詢',
    url: '/stk/stkpq17',
    id: 'stkpq17',
    isCheckPower: true,
  },
  {
    title: '回報查詢',
    url: '/stk/stkpq18',
    id: 'stkpq18',
    isCheckPower: true,
  },
  {
    title: '玉山證API查詢',
    url: '/stk/stkpq19',
    id: 'stkpq19',
    isCheckPower: true,
  },
  {
    title: '股票技術分析手機版',
    url: '/stk/stkpq20',
    id: 'stkpq20',
    isCheckPower: true,
  },

  {
    title: '股票通知查詢2',
    url: '/stk/stkpq11',
    id: 'stkpq11',
    isCheckPower: true,
  },
  {
    title: '群組設定建立作業',
    url: '/stk/stkpi13',
    id: 'stkpi13',
    isCheckPower: true,
  },
  {
    title: '選股中心建立',
    url: '/stk/stkpi17',
    id: 'stkpi17',
    isCheckPower: true,
  },
  {
    title: '追蹤股票建立',
    url: '/stk/stkpi19',
    id: 'stkpi19',
    isCheckPower: true,
  },
  {
    title: '股票通知訊息建立',
    url: '/stk/stkpi20',
    id: 'stkpi20',
    isCheckPower: true,
  },
  {
    title: '股票基本資料建立',
    url: '/stk/stkpi01',
    id: 'stkpi01',
    isCheckPower: true,
  },
  {
    title: '股票走勢圖',
    url: '/stock',
    icon: 'git-network',
    id: 'stock',
    isCheckPower: true,
  },
  {
    title: '技術分析資料查詢',
    url: '/stk/stkpq08',
    icon: 'git-network',
    id: 'stkpq08',
    isCheckPower: true,
  },
  // stock end =========


  ];
/*
export const stkRoutes: Routes = [
  // stock begin========
  {
    path: '/stk/stock',
    component: StockPage,
    //canActivate: [ AuthGuardService ]
  },
  {
    path: '/stk/stkpb04',
    component: Stkpb04Component,
    //canActivate: [ AuthGuardService ]
  },
  {
    path: '/stk/stkpi01',
    component: Stkpi01BillComponent,
    //canActivate: [ AuthGuardService ]
  },
  {
    path: '/stk/stkpi13',
    component: Stkpi13BillComponent,
    //canActivate: [ AuthGuardService ]
  },
  {
    path: '/stk/stkpi17',
    component: Stkpi17BillComponent,
    //canActivate: [ AuthGuardService ]
  },
  {
    path: '/stk/stkpi19',
    component: Stkpi19BillComponent,
    //canActivate: [ AuthGuardService ]
  },
  {
    path: '/stk/stkpi20',
    component: Stkpi20BillComponent,
    //canActivate: [ AuthGuardService ]
  },
  {
    path: '/stk/stkpq08',
    component: Stkpq08Page,
  },
  {
    path: '/stk/stkpq09',
    component: Stkpq09Page,
  },
  {
    path: '/stk/stkpq10',
    component: Stkpq10Page,
  },
  {
    path: '/stk/stkpq13',
    component: Stkpq13Component,
  },
  {
    path: '/stk/stkpq14',
    component: Stkpq14Component,
  },
  {
    path: '/stk/stkpq15',
    component: Stkpq15Component,
  },
  {
    path: '/stk/stkpq16',
    component: Stkpq16Component,
  },
  {
    path: '/stk/stkpq17',
    component: Stkpq17Component,
  },
  {
    path: '/stk/stkpq18',
    component: Stkpq18Component,
  },
  {
    path: '/stk/stkpq19',
    component: Stkpq19Component,
  },
  // stock end =========
];
*/
